import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../Helpers/Contexts/AuthContext';
import TermsGate from './TermsGate';

/**
 * <ProtectedRoute>
 *
 * Wrapper que protege rotas autenticadas.
 * - Enquanto a sessão inicial está carregando, exibe um spinner centralizado.
 * - Se não houver sessão, redireciona silenciosamente para "/" (login).
 * - Se autenticado, renderiza os filhos normalmente.
 *
 * Uso:
 *   <Route path="/home" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
 */
export default function ProtectedRoute({ children }) {
    const { isAuthenticated, loadingAuth } = useAuth();
    const location = useLocation();

    // Aguarda resolução da sessão antes de tomar qualquer decisão
    if (loadingAuth) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    bgcolor: 'background.paper',
                }}
            >
                <CircularProgress color="primary" />
            </Box>
        );
    }

    // Não autenticado → redireciona para o login, preservando a rota tentada
    if (!isAuthenticated) {
        return <Navigate to="/" replace state={{ from: location }} />;
    }

    return <TermsGate>{children}</TermsGate>;
}
